import React, { Fragment } from 'react';
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap'
import './Header.css'

const Header = (props) => {
    return (
        <div>
            <Navbar dark expand="md" className="header">
                <Nav className="container-fluid" navbar>
                    <NavItem>
                        <NavbarBrand href="/conversations">Recording As A Service</NavbarBrand>
                    </NavItem>

                    <NavItem className='ml-auto'>
                        <NavLink href="/conversations">Conversations</NavLink>
                    </NavItem>
                    {props.role === 'admin' ?
                        (<Fragment><UncontrolledDropdown
                            nav
                            inNavbar
                        >
                            <DropdownToggle nav caret>
                                Configuration
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem>
                                    <NavLink href="/management/users/">Users</NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink href="/management/searchview">Search View</NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink href="/management/restrictions">Restrictions</NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                            >
                                <DropdownToggle nav caret>
                                    Audit Log
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem>
                                        <NavLink href="/audits/access/">Access Report</NavLink>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <NavLink href="/audits/searchterms/">Common Search Terms</NavLink>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Fragment>)
                        : <Fragment></Fragment>}
                </Nav>
            </Navbar>
        </div>
    );
}

export default Header;